import React, { useState } from 'react';
import { FaFacebook, FaLinkedin, FaInstagram, FaTiktok, FaArrowLeft } from 'react-icons/fa';
import Header from './Header';
import Footer from './Footer';


const PrivacyPolicy = () => {
    return (
    <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Header />
        <div style={{ flex: 1 }}>

    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem', backgroundColor: '#fff', minHeight: '100vh' }}>
      
      <div style={{ lineHeight: '1.6', color: '#333' }}>
        <h1 style={{ color: '#2c3e50', marginBottom: '1rem', fontSize: '2.5rem', fontWeight: '700' }}>
          LYNCFIT LTD Privacy Policy
        </h1>
        
        <p style={{ fontStyle: 'italic', marginBottom: '2rem', color: '#666' }}>
          Last updated: 11 July 2025
        </p>
        
        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Introduction
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            LYNCFIT LTD ("LyncFit", "we", "us", "our") is committed to respecting and protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and protect your personal information when you use our website, mobile applications, and related services ("Services"). By using our Services, you consent to the practices described in this policy.
          </p>
          <p style={{ marginBottom: '1rem' }}>
            LYNCFIT LTD is a company registered in the United Kingdom, operating globally. For any questions or further information, please contact us at:
          </p>
          <p style={{ fontWeight: '600', color: '#007bff' }}>
            info@lyncfit.co.uk
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Definitions
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>Personal Data:</strong> Any information relating to an identified or identifiable individual.
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>Services:</strong> The LyncFit website, mobile applications, and related offerings.
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>User Content:</strong> Any data, images, or information you upload or share via our Services.
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Data We Collect
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>Personal Information:</strong> Name, email address, date of birth, gender, and password upon registration.
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>Location Data:</strong> Used to connect you with local fitness activities and partners; only collected when the app is in use. You may disable location sharing in your device settings.
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>Event and Activity Data:</strong> Information about events you create or join, including start locations.
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>User Content:</strong> Photos, training logs, and other content you choose to share.
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>Technical Data:</strong> Device identifiers, IP address, operating system, cookies, and usage logs for service improvement and security.
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Legal Grounds for Processing Data
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            We process your personal data only when we have a valid legal basis under the UK General Data Protection Regulation (UK GDPR):
          </p>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>Contract:</strong> Necessary to provide our core services (e.g., account creation, matchmaking).
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>Consent:</strong> For optional features (e.g., marketing communications, analytics, non-essential cookies), we seek your explicit, informed consent.
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>Legitimate Interests:</strong> For our legitimate business interests (e.g., improving the app, fraud prevention), provided these do not override your rights and freedoms.
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>Legal Obligation:</strong> Where required to comply with applicable laws or regulatory requirements.
            </li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            How We Use Your Data
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>To create and manage your account.</li>
            <li style={{ marginBottom: '0.5rem' }}>To facilitate matching with compatible workout partners and events.</li>
            <li style={{ marginBottom: '0.5rem' }}>To personalise and improve your experience.</li>
            <li style={{ marginBottom: '0.5rem' }}>To communicate with you and respond to your requests.</li>
            <li style={{ marginBottom: '0.5rem' }}>For analytics, security, and fraud prevention.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Data Retention
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            We retain your personal data only as long as necessary to provide our Services or as required by law. Data may be anonymised or aggregated for statistical purposes when no longer personally identifiable.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Data Sharing
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>Third-Party Service Providers:</strong> IT vendors, cloud hosting, analytics platforms, and advisors who support our Services.
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>Legal Compliance:</strong> Where required by law, to law enforcement or regulatory authorities.
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>Business Transactions:</strong> In the event of a merger, acquisition, or sale, your data may be transferred as part of the transaction.
            </li>
          </ul>
          <p style={{ marginBottom: '1rem' }}>
            All third-party providers are contractually required to implement appropriate security measures and may only use your data for purposes specified by LYNCFIT LTD.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            International Users & Regional Rights
          </h2>
          <ul style={{ paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>UK & EU:</strong> You have the right to access, correct, or delete your personal data.
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>United States (Connecticut, Utah, Virginia):</strong> Residents have rights under applicable state privacy laws, including access, correction, deletion, and opting out of certain uses.
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>Australia & New Zealand:</strong> We comply with the Privacy Act 1988 (Australia) and Privacy Act 2020 (New Zealand).
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <strong>South Africa:</strong> You have the right to access or correct your personal data and to lodge complaints with the Information Regulator.
            </li>
          </ul>
          <p style={{ marginBottom: '1rem' }}>
            To exercise your rights, contact info@lyncfit.co.uk.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Data Security
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            We use industry-standard security measures, including SSL encryption, to protect your data during transmission and storage. Access is restricted to authorised personnel only. While we strive to protect your information, no method of electronic storage or transmission is completely secure.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Cookies and Tracking
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            Where cookies or similar technologies are used, we provide clear notice and obtain your consent as required by the Privacy and Electronic Communications Regulations (PECR). Please refer to our Cookie Policy for further details.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Children's Privacy
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            LYNCFIT LTD is not intended for users under 18 years of age. If we become aware that a child under 18 has provided personal information, we will delete such data and terminate the account.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ color: '#34495e', marginBottom: '1rem', fontSize: '1.8rem', fontWeight: '600' }}>
            Changes to This Policy
          </h2>
          <p style={{ marginBottom: '1rem' }}>
            We may update this Privacy Policy from time to time. The latest version will be posted on our website with the revised date. Significant changes may be communicated to you directly or via the app.
          </p>
        </section>
      </div>
    </div>

      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;